<template>
  <b-modal
      id="drivers"
      ref="driversTable"
      @shown="restoreSelection"
      @ok="okTapped"
      @hidden="modalClosed"
      size="xl"
      centered
      :lazy="false"
      title="Select driver(s)"
  >

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <p class="text-muted font-13 mb-4"></p>
                <div class="row mb-md-2">

                  <div class="col-sm-12 col-md-4">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Actions -->
                  <!-- Search -->
                  <div class="col-sm-12 col-md-4">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      :items="tableData"
                      :fields="fields"
                      v-model="currentItems"
                      ref="selectableTable"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      selectable
                      @row-selected="onRowSelected"
                  >
                    <template #head(checkbox)>
                      <b-form-checkbox
                          v-model="allSelected"
                          @change="toggleAllRows"
                      ></b-form-checkbox>
                    </template>

                    <template #cell(checkbox)="row">
                      <b-form-checkbox
                          :checked="$refs.selectableTable && $refs.selectableTable.isRowSelected(row.index)"
                          @click.stop
                          @change="onCheckBoxChanged(row)"
                      />
                    </template>

                    <template v-slot:cell(name)="row">
                      {{row.item.name}} {{row.item['other_names']}}
                    </template>



                  </b-table>
                </div>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <div class="pagination-wrapper">
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          :limit="5"
                          first-number
                          last-number
                          pills
                          class="mb-0"
                      ></b-pagination>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

  </b-modal>
</template>

<script>

export default {
  name: "share-driver-list",
  props: {
    selectedDrivers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      currentItems: [],
      selectedItems: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "checkbox",
          label: "",
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "phone",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        }
      ],
      allSelected: false,
    };
  },

  computed: {
    tableData() {
      return  this.$store.getters.GET_DRIVERS;
    },
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    modalClosed() {
      this.$emit("on-drivers-selected", this.selectedItems);
    },
    restoreSelection() {
      this.$nextTick(() => {
        const table = this.$refs.selectableTable;
        if (!table) return;
        table.clearSelected();
        this.currentItems.forEach((item, index) => {
          if (this.selectedDrivers.some(d => d.id === item.id)) {
            table.selectRow(index);
          }
        });
      });
    },
    okTapped(){
      console.log('okTapped selectedRows',this.selectedItems)
     this.$emit('on-drivers-selected', this.selectedItems)
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(selectedRows) {
      this.selectedItems = selectedRows;

      this.allSelected =
          this.currentItems.length > 0 &&
          selectedRows.length === this.currentItems.length;
    },
    toggleAllRows(checked) {
      if (checked) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    onCheckBoxChanged(row){
      const index = row['index']
      if(this.$refs.selectableTable.isRowSelected(index)){
        this.$refs.selectableTable.unselectRow(index)
      }else{
        this.$refs.selectableTable.selectRow(index)
      }
    }
  },
  created() {
    this.$store.dispatch('getDrivers', {limit: 1000, status: ''});
    // Set the initial number of items
  }

}
</script>

<style scoped>
.pagination-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  padding-bottom: 6px;
}

.pagination-wrapper .pagination {
  flex-wrap: nowrap;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .pagination-wrapper {
    justify-content: center;
  }
}
</style>